import React, { Component, FunctionComponent } from "react"
import {connect} from "react-redux";

import style from "./SkinTrack.scss";
import Mark from "./Mark";
import {addMark, deleteMark, moveMark} from "../Store/Actions";

class SkinTrack extends Component
{
    constructor(props)
    {
        super(props);
        this.container = React.createRef();
        this.markRefs = [];
    }

    componentDidMount()
    {
        this.setState({trashHover: false});
    }

    onDragOver(e)
    {
        e.preventDefault();
    };

    onDragStart(e, color)
    {
        if(this.props.skinTrack && this.props.skinTrack.isLocked) {
            return;
        }

        let transfer = Date.now() + ',' + color;
        e.dataTransfer.setData('text/plain', transfer);
    }

    onDrop(e)
    {
        if(this.props.skinTrack && this.props.skinTrack.isLocked) {
            return;
        }

        let fromLeft = this.calculateFromLeft(e.clientX);
        let fromTop = this.calculateFromTop(e.clientY);
        let transfer = e.dataTransfer.getData('text/plain');
        let split = transfer.split(",");

        if(split.length === 1) {
            this.props.moveMark(
                this.props.skinTrack.customerUuid,
                this.props.skinTrack.id,
                parseInt(split[0]),
                fromLeft,
                fromTop
            );
        } else {
            this.props.addMark(
                this.props.skinTrack.customerUuid,
                this.props.skinTrack.id,
                parseInt(split[0]), // markId
                split[1],  // color
                fromLeft,
                fromTop
            )
        }

        e.preventDefault();
    };

    onDropTrash(e)
    {
        if(this.props.skinTrack && this.props.skinTrack.isLocked) {
            return;
        }

        let markId = parseInt(e.dataTransfer.getData('text/plain')) ;

        this.props.deleteMark(
            this.props.skinTrack.customerUuid,
            this.props.skinTrack.id,
            markId,
        );

        this.setState({trashHover: false});

        e.preventDefault();
    };

    handleTrashHover()
    {
        if(this.props.skinTrack && this.props.skinTrack.isLocked) {
            return;
        }

        this.setState({trashHover: !this.state.trashHover});
    }

    calculateFromLeft(posX)
    {
        let containerRect = this.container.current.getBoundingClientRect();
        let containerLeft = containerRect.left;
        let fromLeftPX = posX - containerLeft - 15;

        return fromLeftPX / (containerRect.width / 100);
    }

    calculateFromTop(posY)
    {
        let containerRect = this.container.current.getBoundingClientRect();
        let containerTop = containerRect.top;
        let fromTopPX = posY - containerTop - 15;

        return fromTopPX / (containerRect.height / 100);
    }

    render()
    {
        let skinTrack = this.props.skinTrack;
        let locked = skinTrack ? skinTrack.isLocked : true;
        let marks = [];
        let self = this;
        let backgroundImage = '';

        if (skinTrack !== null) {
            skinTrack.marks.forEach(function(mark) {
                let markRef = React.createRef();
                let markEl = <Mark mark={mark} key={'mark'+mark.id} ref={markRef} lockMode={locked}/>;
                self.markRefs[mark.id] = markRef;
                marks.push(markEl);
            });
            backgroundImage = skinTrack.limb + '.png';
        }

        let hover = false;
        if(this.state) {
            hover = this.state.trashHover;
        }

        let classNames = require('classnames');
        let classes = classNames({
            [style.thrash]: true,
            [style.hover]: hover
        });

        let colors = [
            '#f44336',
            '#673ab7',
            '#2196f3',
            '#4caf50',
            '#cddc39',
            '#ff9800',
            '#795548',
            '#9e9e9e'
        ];

        let markClasses = classNames({
            [style.mark]: true,
            [style.locked]: locked
        });

        let lockClasses = classNames({
            [style.lockMode]: true,
            [style.hidden]: skinTrack ? !locked : true
        });

        let statusClasses = classNames({
            [style.status]: true,
            [style.loading]: this.props.requests > 0
        });

        let loadingGif = "/react/public/skintrack/loading.gif";

        return (
            <div className={style.skinTrackContainer}>
                <div
                    className={lockClasses}
                >
                    <p><small>Je bekijkt een vorige versie. Deze kan niet bewerkt worden.</small></p>
                </div>
                <div className={style.marks}>
                    {
                        colors.map((color) =>
                            <div
                                className={markClasses}
                                style={{background: color}}
                                onDragStart={(e)=>this.onDragStart(e, color)}
                                draggable={!locked}
                                data-color={color}
                                key={color}
                            >&nbsp;</div>
                        )
                    }
                    <div className={classes}
                         onDrop={(e)=>this.onDropTrash(e)}
                         onDragOver={(e)=>this.onDragOver(e)}
                         onDragEnter={()=>this.handleTrashHover()}
                         onDragLeave={()=>this.handleTrashHover()}
                    />
                </div>
                {
                    skinTrack === null
                        ?
                            <div style={{'margin': '0 auto', 'width': '100px', 'height': '100px', 'display': 'block', 'textAlign': 'center'}}>
                                <img src={loadingGif} width={'100px'}/><br/>
                                <p>Laden...</p>
                            </div>
                        :
                            <div
                                className={style.skinTrack}
                                style={{backgroundImage: 'url(\'/react/public/skintrack/'+backgroundImage+'\')'}}
                                ref={this.container}
                                onDrop={(e)=>this.onDrop(e)}
                                onDragOver={(e)=>this.onDragOver(e)}
                            >
                                { marks }
                            </div>
                }
                <div className={statusClasses} />
            </div>
        )
    }
}

const mapStateToProps = function(state) {
    return {
        requests: state.skin_tracks.requests
    }
};

const mapDispatchProps = function(dispatch) {
    return {
        moveMark: (customerId, skinTrackId, markId, fromLeft, fromTop) => dispatch(moveMark(skinTrackId, customerId, markId, fromLeft, fromTop)),
        deleteMark: (customerId, skinTrackId, markId) => dispatch(deleteMark(skinTrackId, customerId, markId)),
        addMark: (customerId, skinTrackId, markId, color, fromLeft, fromTop) => dispatch(addMark(skinTrackId, customerId, markId, fromLeft, fromTop, color))
    }
};

export default connect(mapStateToProps, mapDispatchProps)(SkinTrack);
